import React from 'react';
import { Drawer, IconButton, Container, Grid, Typography } from '@mui/material';
import HighlightOffSharpIcon from '@mui/icons-material/HighlightOffSharp';

/**
 * 展示富文本内容的通用 Drawer 组件
 * props:
 *  - open: 是否打开
 *  - onClose: 关闭回调
 *  - title: 标题（可选）
 *  - content: 富文本字符串（HTML）
 */
export default function RichTextDrawer(props) {
  const { open, onClose, title, content } = props;

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiPaper-root': {
          borderTopLeftRadius: '15px !important',
          borderTopRightRadius: '15px !important',
          maxHeight: '95vh',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      {/* 顶部关闭按钮，固定在 Drawer 顶部，不随内容滚动 */}
      <div
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 10,
          display: 'flex',
          justifyContent: 'flex-end',
          padding: '8px 12px 0 12px',
          background: 'linear-gradient(to bottom, rgba(255,255,255,0.95), rgba(255,255,255,0.7), rgba(255,255,255,0))',
        }}
      >
        <IconButton
          aria-label="close"
          size="medium"
          onClick={onClose}
        >
          <HighlightOffSharpIcon fontSize="medium" />
        </IconButton>
      </div>
      <Container sx={{ paddingTop: 1, paddingBottom: 4, overflowY: 'auto' }}>
        {title && (
          <Typography
            variant="h6"
            component="div"
            sx={{ fontWeight: 'bold', mb: 2 }}
          >
            {title}
          </Typography>
        )}
        {content && (
          <Grid sx={{ fontSize: '0.9rem', color: '#333' }}>
            {/* 直接渲染富文本 HTML */}
            <Typography
              component="div"
              variant="body1"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </Grid>
        )}
      </Container>
    </Drawer>
  );
}


